import { API_BASE } from '../constants';
import { getData } from '../_base';
import { InformativeTextDto } from '../../dto/DynamicControlDto';
import { getCurrentLanguageDto } from '../../utilitys/language';

const base = `${API_BASE}/v1/InformativeText`;

const url = {
  getByLanguage: `${base}/InformativeText`,
};

export const getInformativeTextByLangApi = async (): Promise<InformativeTextDto[]> => {
  const lngDto = getCurrentLanguageDto();
  const _url = `${url.getByLanguage}/${lngDto.id}`;
  const result = await getData<InformativeTextDto[]>(_url);
  if (result && !result.hasError && result.data ) return result.data;
  else return [];
};
